import {
  ADD_GAME_TO_HISTORY,
  SET_CURRENTSCORE,
  SET_HIGHSCORE,
  SET_MINI_GAMES_DATA,
  SET_MINI_GAMES_LIST
} from '../actions/mini-games-action-types';

const initialState = {
  gameDetails: {
    gameName: '',
    gameImage: '',
    gameURL: '',
    leaderboard: [],
    gameId: '',
    gameSlug: '',
    contest: {},
    highScore: 0,
    currentScore: 0
  },
  gamesHistory: [],
  miniGamesList: []
};

export default function minigames(state = initialState, action: { type: any; payload: any }) {
  switch (action.type) {
    case SET_MINI_GAMES_DATA: {
      const item = action.payload;
      return {
        ...state,
        gameDetails: {
          ...item
        }
      };
    }
    case SET_CURRENTSCORE: {
      return {
        ...state,
        gameDetails: {
          ...state.gameDetails,
          currentScore: action.payload
        }
      };
    }
    case SET_HIGHSCORE: {
      return {
        ...state,
        gameDetails: {
          ...state.gameDetails,
          highScore: action.payload
        }
      };
    }
    case ADD_GAME_TO_HISTORY: {
      const alreadyExist = state.gamesHistory.find(
        (item: any) => item.gameName === action.payload.gameName
      );

      if (!alreadyExist) {
        return {
          ...state,
          gamesHistory: [action.payload, ...state.gamesHistory]
        };
      } else {
        return {
          ...state
        };
      }
    }

    case SET_MINI_GAMES_LIST:
      return {
        ...state,
        miniGamesList: action.payload
      };

    default:
      return state;
  }
}
